// @flow

import { RECEIVED_ASSORTMENT_SETTINGS } from './constants';
import type { State } from './types';
import type { ReceivedAssortmentSettings } from './actions';

const initialState: State = {
  filter_button: '',
  remove_filters_button: '',
  actionable_filter_button: '',
  make: '',
  fueltype: '',
  price: '',
  size: '',
  transmission: '',
  bodywork: '',
  product_type: '',
  result_title: '',
  result_title_plural: '',
  close_text: '',
  sort_option_name_asc: '',
  sort_option_name_desc: '',
  sort_option_price_asc: '',
  sort_option_price_desc: '',
  sort_option_delivery_time_asc: '',
  sort_option_delivery_time_desc: '',
  assortment_category_title: '',
  custom_filter_heading: '',
  custom_filter_deliverytime: '',
  custom_filter_vbmr: '',
  custom_filter_deliverytime_duration: '',
};

export default (state: State = initialState, action: ReceivedAssortmentSettings): State => {
  switch (action.type) {
    case RECEIVED_ASSORTMENT_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
